
import React from 'react';
import { Form } from "@/components/ui/form";
import FormNameField from './FormNameField';
import FormEmailField from './FormEmailField';
import FormCompanyField from './FormCompanyField';
import FormPhoneField from './FormPhoneField';
import FormDesiredOutcomeField from './FormDesiredOutcomeField';
import FormTermsField from './FormTermsField';
import { useSignupForm } from './useSignupForm';

const SignUpForm = () => {
  const { form, isSubmitting, onSubmit } = useSignupForm();

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log('🎯 Form submit event triggered');
    console.log('📋 Form is valid:', form.formState.isValid);
    console.log('🔍 Form errors:', form.formState.errors);
    console.log('📊 Current form values:', form.getValues());
    
    // First trigger validation
    const isValid = await form.trigger();
    console.log('✅ Manual validation result:', isValid);
    
    if (isValid) {
      console.log('✅ Form is valid, proceeding with submission');
      const formData = form.getValues();
      await onSubmit(formData);
    } else {
      console.log('❌ Form validation failed:', form.formState.errors);
    }
  };

  return (
    <div className="rounded-lg bg-synthreo-black-light p-8 max-w-2xl mx-auto">
      {/* Hidden static form for Netlify Forms detection */}
      <form name="synthreo-signup" data-netlify="true" style={{ display: 'none' }}>
        <input type="text" name="name" />
        <input type="email" name="email" />
        <input type="text" name="company" />
        <input type="tel" name="phone" />
        <input type="text" name="desiredOutcome" />
        <input type="checkbox" name="agreeToTerms" />
      </form>

      <Form {...form}>
        <form 
          className="space-y-6"
          onSubmit={handleFormSubmit}
          data-netlify="true"
          name="synthreo-signup"
        >
          {/* Hidden Netlify form fields */}
          <input type="hidden" name="form-name" value="synthreo-signup" />
          
          <FormNameField control={form.control} />
          <FormEmailField control={form.control} />
          <FormCompanyField control={form.control} />
          <FormPhoneField control={form.control} />
          <FormDesiredOutcomeField control={form.control} />
          <FormTermsField control={form.control} />
          
          <button
            type="submit"
            className="btn-glow w-full rounded-md py-3 text-white transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Create Account"}
          </button>
        </form>
      </Form>
    </div>
  );
};

export default SignUpForm;
